export const Divider = { baseStyle: { borderColor: "border.default", opacity: 1 } };
